const Insights = () => {
  console.log('ii')
  const categories = document.querySelectorAll('.js-category-link');
  const postsContainer = document.querySelector('.js-category-posts');

  if(categories.length > 0 && postsContainer !== null) {
    console.log('iii')
    categories.forEach(category => {
      category.addEventListener('click', e => {
        e.preventDefault();
        
        window.jQuery.ajax({
          type: 'POST',
          url: '/wp-admin/admin-ajax.php',
          dataType: 'html',
          data: {
            'action' : 'get_articles',
            'get_page' : 1,
            'get_category' : category.dataset.categoryId,
          },
          success: function(data) {
            postsContainer.innerHTML = data;

            categories.forEach(category => {
              category.classList.remove('hero-articles__item_active');
            })
            category.classList.toggle('hero-articles__item_active');
          },
          error: function(data) {
            console.log(data);
          }
        });
      })
    })
  }
}

export default Insights;